import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colors } from '../theme';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const isKo = i18n.language?.startsWith('ko');

  const toggle = () => {
    i18n.changeLanguage(isKo ? 'en' : 'ko');
  };

  return (
    <Box
      onClick={toggle}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.25,
        px: 1,
        py: 0.5,
        borderRadius: 999,
        border: `1px solid ${colors.border}`,
        cursor: 'pointer',
        userSelect: 'none',
        '&:hover': { borderColor: colors.borderStrong },
      }}
    >
      <Typography
        sx={{
          fontSize: '0.6875rem',
          fontWeight: isKo ? 500 : 700,
          color: isKo ? colors.textFaint : colors.text,
          px: 0.5,
        }}
      >
        EN
      </Typography>
      <Box
        sx={{
          width: 1,
          height: 12,
          backgroundColor: colors.border,
        }}
      />
      <Typography
        sx={{
          fontSize: '0.6875rem',
          fontWeight: isKo ? 700 : 500,
          color: isKo ? colors.text : colors.textFaint,
          px: 0.5,
        }}
      >
        KO
      </Typography>
    </Box>
  );
}
